export const pageNames = {
  HOME: 'Home',
  CREATEPALLETPATTERN: 'CreatePalletPattern',
  VIEWPALLETPATTERNS: 'ViewPalletPatterns',
  DETAILS: 'Details',
  EDITPALLETPATTERN: 'EditPalletPattern',
  SETTINGS: 'Settings',
  MACHINESETTINGS: 'MachineSettings',
  EDITLAYERPATTERN: 'EditLayerPattern',
  LICENSE: 'License',
  ABOUT: 'About',
  USERMANAGEMENT: 'UserManagement',
  DOCUMENTVIEWER: 'DocumentViewer',
  BACKUPRESTORE: 'BackupRestore',
  AUDITTRAIL: 'AuditTrail'
}
